if (!customElements.get('product-wobb')) {
  customElements.define(
    'product-wobb',
    class ProductWobb extends HTMLElement {
      connectedCallback() {
        this.qtyInput = this.querySelector('[data-qty]');
        this.totalEl = this.querySelector('[data-total]');
        this.stickyTotal = this.querySelector('[data-sticky-total]');
        this.unitPrice = parseInt(this.dataset.price, 10) || 0;
        this.form = this.querySelector('form[data-type="add-to-cart-form"]');

        this.querySelectorAll('[data-qty-step]').forEach((button) =>
          button.addEventListener('click', () => this.setQty(this.getQty() + parseInt(button.dataset.qtyStep, 10)))
        );
        this.qtyInput?.addEventListener('input', () => this.updateTotal());
        this.qtyInput?.addEventListener('change', () => this.setQty(this.getQty()));

        this.initCalculator();
        this.initLightbox();
        this.initSticky();
        this.updateTotal();
      }

      getQty() {
        return Math.max(1, parseInt(this.qtyInput?.value, 10) || 1);
      }

      setQty(value) {
        if (!this.qtyInput) return;
        this.qtyInput.value = Math.max(1, Math.min(99, value));
        this.updateTotal();
      }

      formatMoney(cents) {
        return (cents / 100).toLocaleString('nl-NL', { style: 'currency', currency: this.dataset.currency || 'EUR' });
      }

      updateTotal() {
        const qty = this.getQty();
        const total = this.formatMoney(this.unitPrice * qty);
        if (this.totalEl) this.totalEl.textContent = qty > 1 ? `· ${total}` : '';
        if (this.stickyTotal) this.stickyTotal.textContent = total;
      }

      initCalculator() {
        const calc = this.querySelector('[data-calc]');
        if (!calc) return;
        const width = calc.querySelector('[data-calc-width]');
        const length = calc.querySelector('[data-calc-length]');
        const depth = calc.querySelector('[data-calc-depth]');
        const output = calc.querySelector('[data-calc-output]');
        const apply = calc.querySelector('[data-calc-apply]');
        const parse = (v) => parseFloat(String(v || '').replace(',', '.'));
        let bags = 0;

        const run = () => {
          const m3 = parse(width.value) * parse(length.value) * (parse(depth.value) / 100);
          if (!(m3 > 0)) {
            output.textContent = output.dataset.empty;
            apply.hidden = true;
            return;
          }
          bags = Math.max(1, Math.ceil(m3));
          const m3Text = m3.toLocaleString('nl-NL', { maximumFractionDigits: 2 });
          output.innerHTML = `${m3Text}m³ nodig: <strong>${bags} big bag${bags > 1 ? 's' : ''}</strong>`;
          apply.textContent = `Neem ${bags} over`;
          apply.hidden = false;
        };

        [width, length, depth].forEach((field) => field.addEventListener('input', run));
        [width, length].forEach((field) =>
          field.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') event.preventDefault();
          })
        );
        apply.addEventListener('click', () => {
          this.setQty(bags);
          this.qtyInput.focus();
        });
        run();
      }

      initLightbox() {
        const dialog = this.querySelector('[data-lightbox]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const img = dialog.querySelector('img');
        this.querySelectorAll('[data-zoom]').forEach((button) =>
          button.addEventListener('click', () => {
            img.src = button.dataset.zoom;
            img.alt = button.dataset.alt || '';
            dialog.showModal();
          })
        );
        dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      }

      initSticky() {
        const bar = this.querySelector('[data-sticky]');
        const buy = this.querySelector('[data-buy]');
        if (!bar || !buy || !('IntersectionObserver' in window)) return;

        new IntersectionObserver(([entry]) => {
          bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        }).observe(buy);

        bar.querySelector('button').addEventListener('click', () => {
          if (this.form?.requestSubmit) this.form.requestSubmit();
          else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    }
  );
}
